import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Music } from "lucide-react";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <header className="bg-[#FAF9F6]/90 backdrop-blur-md border-b border-[#6B8576]/10 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-[#6B8576] rounded-2xl flex items-center justify-center">
              <Music className="w-4 h-4 text-white" strokeWidth={1.5} />
            </div>
            <span className="font-semibold text-[#2A3A31]" style={{ fontFamily: 'Outfit' }}>Audio Sur Mesure</span>
          </Link>
          <Link to="/" className="text-sm text-[#6B8576] font-medium hover:underline flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="mentions-legales-page">
        <h1 className="text-3xl font-semibold text-[#2A3A31] mb-8" style={{ fontFamily: 'Outfit' }}>Mentions légales</h1>
        
        <div className="prose prose-sm max-w-none space-y-8 text-[#2C3531]" style={{ fontFamily: 'Manrope' }}>
          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Éditeur du site</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Lynda Bry-Bonnard<br />
              Hypnothérapeute et praticienne EMDR<br />
              1 rue des écoles, 16100 Javrezac<br />
              Téléphone : 06 64 26 00 50<br />
              Email : brylynda@gmail.com<br />
              Site web : <a href="https://lyndabrybonnard.fr/" target="_blank" rel="noopener noreferrer" className="text-[#6B8576] hover:underline">lyndabrybonnard.fr</a><br />
              Adhérente au SDMH (Syndicat des Métiers de l'Hypnose)
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Hébergement</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Ce site est hébergé par Emergent Labs.<br />
              Les données sont stockées sur des serveurs sécurisés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Propriété intellectuelle</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              L'ensemble du contenu de ce site (textes, exercices, séances audio, graphismes, logos) est la propriété exclusive de Lynda Bry-Bonnard, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Responsabilité</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Les exercices et contenus proposés sur cette application sont des outils de mieux-être et ne se substituent en aucun cas à un diagnostic ou un traitement médical. En cas de détresse psychologique, contactez le 3114 (numéro national de prévention du suicide) ou le 15 (SAMU).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Droit applicable</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
